import { ReportHandler } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS((entry) => {
        console.log('CLS:', entry.name, entry.value);
        onPerfEntry(entry);
      });
      getFID((entry) => {
        console.log('FID:', entry.name, entry.value);
        onPerfEntry(entry);
      });
      getFCP((entry) => {
        console.log('FCP:', entry.name, entry.value);
        onPerfEntry(entry);
      });
      getLCP((entry) => {
        console.log('LCP:', entry.name, entry.value);
        onPerfEntry(entry);
      });
      getTTFB((entry) => {
        console.log('TTFB:', entry.name, entry.value);
        onPerfEntry(entry);
      });
    });
  }
};

export default reportWebVitals;
